import { Language } from './types';

const BASE_LANGUAGE = {
  allRightsReserved: 'All rights reserved',
  disclaimer:
    'For further information about our terms & conditions please read our legal section',
  disclaimerHere: 'here.',
};

type LabelsLanguage = keyof typeof BASE_LANGUAGE;

const FOOTER_LANGUAGE_LABELS: Record<
  Language,
  Record<LabelsLanguage, string | object>
> = {
  EN: BASE_LANGUAGE,
  ES: {
    allRightsReserved: 'Todos los derechos reservados',
    disclaimer:
      'Para más información sobre nuestros términos y condiciones, consulte nuestra sección legal',
    disclaimerHere: 'aquí.',
  },
};

export default FOOTER_LANGUAGE_LABELS;
